
import React, { useState, useEffect } from "react";
import CookieLayerLink from "../components/subpages-footer/CookieLayerLink";
import { useCookies } from "react-cookie";
import Head from "next/head";
import Script from "next/script";
import { Router } from "next/router";
import { useRouter } from "next/router";

const CookieConsent = () => {
  let setMaxAge = 180 * 24 * 60 * 60; // 180 Tage in Sekunden
  const router = useRouter();


  const [cookies, setCookie, removeCookie] = useCookies([
    /*  "marketing", */
    "necessary",
    "statistics",
  ]);

  /* const [marketing, setMarketing] = useState(false); */
  let [necessary, setNecessary] = useState(true);
  let [statistics, setStatistics] = useState(false);
  const [cookieLayer, setCookieLayer] = useState("none");
  const [cookieLayerFade, setCookieLayerFade] = useState();
  const [gtag, addGtag] = useState();
  const [gtagConfig, addGtagConfig] = useState(``);
  const [detailsText, setDetailsText] = useState("einblenden");
  const [cookieContent, setCookieContent] = useState("");

  //GA4 OLD
  /*function loadGa4ScriptDenied() {
    if (!document.getElementById("ga4-script-denied")) {
      const ga4ScriptDenied = document.createElement("script");
      ga4ScriptDenied.id = "ga4-script-denied";
      ga4ScriptDenied.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('consent', 'default', {
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update': 500,
      });
      dataLayer.push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
      `;
      document.head.appendChild(ga4ScriptDenied);
    }
  }*/

  /*function loadGa4Script() {
    if (!document.getElementById("ga4-script")) {
      const ga4Script = document.createElement("script");
      ga4Script.async = true;
      ga4Script.id = "ga4-script";
      ga4Script.src = `
      https://www.googletagmanager.com/gtag/js?id=G-24FN8NH45Q
      `;
      document.head.appendChild(ga4Script);
      
      /* var firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(ga4Script,firstScript); */
  /*}
  }*/

  /*function loadGa4ScriptGranted() {
    if (!document.getElementById("ga4-script-granted")) {
      const ga4ScriptGranted = document.createElement("script");
      ga4ScriptGranted.id = "ga4-script-granted";
      ga4ScriptGranted.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted'
      });
      gtag('js', new Date());
      gtag('config','https://www.googletagmanager.com/gtag/js?id=G-24FN8NH45Q', { 'anonymize_ip': true });
      `;
      document.head.appendChild(ga4ScriptGranted);

    }
  }*/

  //GA4 NEW 2025

  function loadGa4ScriptDenied() {
    if (!document.getElementById("ga4-script-denied")) {
      const ga4ScriptDenied = document.createElement("script");
      ga4ScriptDenied.id = "ga4-script-denied";
      ga4ScriptDenied.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('consent', 'default', {
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update': 500,
      });
      dataLayer.push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
      `;
      document.head.appendChild(ga4ScriptDenied);
    }
  }

  /*   function loadGa4Script() {
    if (!document.getElementById("ga4-script")) {
      const ga4Script = document.createElement("script");
      ga4Script.async = true;
      ga4Script.id = "ga4-script";
      ga4Script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WN22M35C');
      `;
      document.head.appendChild(ga4Script);

    }
  } */

  /*   function loadGa4Script() {
    if (!document.getElementById("ga4-script")) {
      const ga4Script = document.createElement("script");
      ga4Script.async = true;
      ga4Script.id = "ga4-script";
      ga4Script.innerHTML = `
       https://www.googletagmanager.com/gtag/js?id=AW-17149492462
      `;
      document.head.appendChild(ga4Script);
    }
  } */

  function loadGa4Script() {
    if (!document.getElementById("ga4-script")) {
      const ga4Script = document.createElement("script");
      ga4Script.async = true;
      ga4Script.id = "ga4-script";
      ga4Script.src = `
      https://www.googletagmanager.com/gtag/js?id=AW-17149492462
      `;
      document.head.appendChild(ga4Script);
    }
  }

  function loadGa4Layer() {
    if (!document.getElementById("ga4-layer")) {
      const ga4Layer = document.createElement("script");
      ga4Layer.id = "ga4-layer";
      ga4Layer.innerHTML = `
       window.dataLayer = window.dataLayer || [];
       function gtag(){dataLayer.push(arguments);}
       gtag('js', new Date());
       gtag('config', 'AW-17149492462');
      `;
      document.head.appendChild(ga4Layer);
    }
  }

  function loadGa4ScriptGranted() {
    if (!document.getElementById("ga4-script-granted")) {
      const ga4ScriptGranted = document.createElement("script");
      ga4ScriptGranted.id = "ga4-script-granted";
      ga4ScriptGranted.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted'
      });
      `;
      document.head.appendChild(ga4ScriptGranted);
    }
  }

  //OLD - not in use - Matomo hybrid - cookie & cookieless
  /* function loadMatomoScriptOLD(cookiesOn) {
    if (!document.getElementById("matomo-script")) {
      const matomoScript = document.createElement("script");
      matomoScript.id = "matomo-script";
      matomoScript.innerHTML = `
      var _paq = window._paq = window._paq || [];
      _paq.push(['disableBrowserFeatureDetection']);
      _paq.push(['requireCookieConsent']);
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u="//t.hacker-pschorr.de/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '10']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
      })();
      `;
      document.head.appendChild(matomoScript);
    }

     if (cookiesOn) {
        _paq.push(["setCustomDimension", 1, "Akzeptiert"]);
        _paq.push(["setCookieConsentGiven"]);
      } else {
        _paq.push(["setCustomDimension", 1, "Abgelehnt"]);
      }

    loadMatomoEvents();
  } */

    // Matomo Script mit & ohne Cookies 
    function loadMatomoScript(cookiesOn) {
      const url = window.location.pathname + window.location.search;
      var _paq = (window._paq = window._paq || []);
      _paq.push(["disableBrowserFeatureDetection"]);
      _paq.push(["requireCookieConsent"]);
    
      if (cookiesOn) {
        //console.log("Matomo incl. cookies");
        _paq.push(["setCustomDimension", 1, "Akzeptiert"]);
        _paq.push(["setCookieConsentGiven"]);
        loadMatomoEvents();
      } else {
        //console.log("Matomo exl. cookies");
        _paq.push(["setCustomDimension", 1, "Abgelehnt"]);
        loadMatomoEvents();
      }
      //Set custom url & title to fix timing issues
      _paq.push(['setCustomUrl', url]);
      _paq.push(['setDocumentTitle', document.title]);

      _paq.push(["trackPageView"]);
      _paq.push(["enableLinkTracking"]);
      (function () {
        var u = "https://t.paulaner-gruppe.de/";
        _paq.push(["setTrackerUrl", u + "matomo.php"]);
        _paq.push(["setSiteId", "10"]);
        var d = document,
          g = d.createElement("script"),
          s = d.getElementsByTagName("script")[0];
        g.async = true;
        g.src = u + "matomo.js";
        s.parentNode.insertBefore(g, s);
      })();
    }

  function loadMatomoNoScript() {
    const matomoNoScript = document.createElement("noscript");
    const img = document.createElement("img");
    img.src = "//t.paulaner-gruppe.de/matomo.php?idsite=10&amp;rec=1";
    img.style.border = "0";
    img.alt = "";
    matomoNoScript.appendChild(img);
    document.body.appendChild(matomoNoScript);
  }

  function loadMatomoEvents() {
    if (!document.getElementById("matomo-events")) {
      const maeScript = document.createElement("script");
      maeScript.async = true;
      maeScript.id = "matomo-events";
      maeScript.src = `
      /matomoEvents.js
      `;
      document.head.appendChild(maeScript);

      /* var firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(ga4Script,firstScript); */
    }
  }

  useEffect(() => {
    if (
      cookies.necessary ||
      cookies.statistics ||
      (cookies.necessary && cookies.statistics) /* || cookies.marketing */ ||
      window.location.toString().includes("localhost:3010") ||
      window.location.toString().includes("https://hpew.datenwerk.dev/")
    ) {
      hideCookieLayer();
    } else {
      showCookieLayer();
    }
  }, [cookies]);

  //Check cookies on starting the page
  useEffect(() => {
    if (cookies.statistics && cookies.necessary /* && !cookies.marketing */) {
      /* addGtag("https://www.googletagmanager.com/gtag/js?id=G-24FN8NH45Q"); */
      loadGa4ScriptGranted();
      loadGa4Script();
      loadGa4Layer();
      loadMatomoScript(true);
      //loadMatomoScript();
      loadMatomoNoScript();

      /* addGtagConfig(` window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'https://www.googletagmanager.com/gtag/js?id=G-2XWKVJ3TQS');`); */
      /* console.log("statistik cookie active"); */
    } /* else if(cookies.marketing && cookies.statistics && cookies.necessary){
      addGtag("https://www.googletagmanager.com/gtag/js?id=G-2XWKVJ3TQS");

      console.log("all cookies active")
    } */ else if (
      cookies.necessary &&
      !cookies.statistics /*  && !cookies.marketing */
    ) {
      /* addGtag(""); */
      loadMatomoScript();

      /* console.log("necessary cookie active"); */
    } else if (!cookies.necessary && !cookies.statistics) loadGa4ScriptDenied();
  }, [router]);

  useEffect(() => {
    if (window.location.toString().includes("datenschutz"))
      setCookieContent("Cookie-Einstellungen ändern");
  }, []);

  /*   function checkCookie() {
    let userCookieLayer = cL_getCookie(cL_cookie_key);
    // console.log('Test: ' + userCookieLayer);
    if (userCookieLayer === "true") {
      $("body").removeClass("no-scroll");
      cL_Container.hide();
    } else {
      $("body").addClass("no-scroll");
      cL_Container.show();
    }
    return userCookieLayer;
  } */

  const changeDetailsText = () => {
    if (detailsText == "einblenden") {
      setDetailsText("ausblenden");
    } else if (detailsText == "ausblenden") {
      setDetailsText("einblenden");
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    switch (name) {
      /* case "marketingcheck":
        setMarketing(checked);
        if (checked) {
          setStatistics(true);
        }
        break; */
      case "necessarycheck":
        setNecessary(checked);
        break;
      case "statisticscheck":
        setStatistics(checked);
        break;
      default:
        break;
    }
  };

  const hideCookieLayer = () => {
    setCookieLayer("none");
  };

  const showCookieLayer = () => {
    setCookieLayer("flex");
  };

  const setNecessaryCookie = () => {
    setCookie("necessary", necessary, { path: "/", maxAge: setMaxAge });
  };

  const setStatisticsCookie = () => {
    setCookie("statistics", statistics, { path: "/", maxAge: setMaxAge });
  };

  /*  const setMarketingCookie = () => {
    setCookie("marketing", marketing, { path: "/", maxAge: setMaxAge });
  }; */

  const handleAllSelect = () => {
    necessary = true;
    statistics = true;
    /* marketing = true; */
    setStatistics(true);
    setNecessary(true);
    /* setMarketing(true) */

    setNecessaryCookie();
    setStatisticsCookie();
    /* setMarketingCookie(); */
    /* addGtag("https://www.googletagmanager.com/gtag/js?id=G-24FN8NH45Q"); */
    loadGa4ScriptGranted();
    loadGa4Script();
    loadGa4Layer();
    loadMatomoScript(true);
    loadMatomoNoScript();

    /*  setCookie("necessary", necessary, { path: "/", expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) });
    setCookie("statistics", statistics, { path: "/", expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) }); */
    process.env.showCookieLayer = false;
    hideCookieLayer();
  };

  const handleSelectionConfirm = () => {
    if (necessary && !statistics) {
      setNecessaryCookie();
      if (cookies.statistics /* || cookies.marketing */) {
        removeCookie("statistics");
        /*  removeCookie('marketing'); */
        statistics = false;
        /*  marketing = false; */
      }
      loadMatomoScript();

      /* console.log("Necessary true"); */
    } else if (statistics && !necessary) {
      setStatisticsCookie();
      /* addGtag("https://www.googletagmanager.com/gtag/js?id=G-24FN8NH45Q"); */
      loadGa4ScriptGranted();
      loadGa4Script();
      loadGa4Layer();
      loadMatomoScript(true);
      loadMatomoNoScript();

      /*  if( cookies.marketing){
        removeCookie('marketing');
        marketing = false;
      } */
      /* console.log("Statistic true"); */
    } else if (necessary && statistics /* && !marketing */) {
      setNecessaryCookie();
      setStatisticsCookie();
      /* addGtag("https://www.googletagmanager.com/gtag/js?id=G-24FN8NH45Q"); */
      loadGa4ScriptGranted();
      loadGa4Script();
      loadGa4Layer();
      loadMatomoScript(true);
      loadMatomoNoScript();

      /* console.log("Necesary and Statistics true"); */
    } /*  else if (necessary && statistics && marketing) {
      setNecessaryCookie();
      setStatisticsCookie();
      setMarketingCookie();
      console.log("All true");
    } */
    process.env.showCookieLayer = false;
    hideCookieLayer();
  };

  const areAllSelected = necessary && statistics; /* && marketing */

  function toggleDiv() {
    const detailsBox = document.getElementById("detailsBox");

    if (detailsBox.style.height === "0px") {
      detailsBox.style.height = detailsBox.scrollHeight + "px";
    } else {
      detailsBox.style.height = "0px";
    }
  }

  function changeCookies() {
    setCookieLayer("flex");
  }

  /*   let gTag = "https://www.googletagmanager.com/gtag/js?id=G-2XWKVJ3TQS";

  let gTag2 = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'https://www.googletagmanager.com/gtag/js?id=G-2XWKVJ3TQS');
`; */

  return (
    <div>
      <div style={{ display: `${cookieLayer}` }} className="cookie-layer-outer">
        <div className="cookie-layer-inner">
          <div className="cookie-layer-headline-box">
            <h1 className="cookie-layer-headline">Cookie-Einstellungen</h1>
            {/* <img src="/src/EW_logo.png" alt=""></img> */}
          </div>
          <p>
            Wir verwenden in Verbindung mit unserem Internetauftritt sogenannte
            Cookies, um diesen für Sie optimal zu gestalten und kontinuierlich
            zu verbessern. Dabei setzen wir technisch notwendige Cookies ein,
            aber auch solche zu Statistikzwecken oder zur Anzeige
            personalisierter Inhalte. Durch Anklicken der Auswahlmöglichkeiten
            können Sie selbst über die Zulassung von bestimmten Cookies
            entscheiden. Weitere Informationen finden Sie in unserer{" "}
            <a href="/datenschutz" target="_blank">
              Datenschutzerklärung.
            </a>{" "}
            Dort können Sie Ihre Entscheidung jederzeit ändern und weitere
            Informationen zu diesem Thema finden.
          </p>
          <div className="cookie-layer-checkboxes">
            <div className="cookie-layer-checkbox">
              <label style={{ cursor: "not-allowed" }}>
                <input
                  type="checkbox"
                  name="necessarycheck"
                  disabled={true}
                  style={{ cursor: "not-allowed" }}
                  checked={necessary}
                  onChange={handleCheckboxChange}
                />
                Notwendig
              </label>
            </div>
            <div className="cookie-layer-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="statisticscheck"
                  checked={statistics}
                  onChange={handleCheckboxChange}
                />
                Statistik
              </label>
            </div>
            {/*   <div className="cookie-layer-checkbox">
            <label>
              <input
                type="checkbox"
                name="marketingcheck"
                checked={marketing}
                onChange={handleCheckboxChange}
              />
              Marketing
            </label>
          </div> */}

            <div onClick={toggleDiv} className="cookie-layer-details-link">
              <a onClick={changeDetailsText} href="#">
                Details {detailsText}
              </a>
            </div>
          </div>
          <div
            /* style={{ display: `${details}` }} */
            style={{ height: "0px" }}
            className="cookie-layer-details-box"
            id="detailsBox"
          >
            <p className="cookie-layer-details-box-headline">
              <b>Notwendig:</b>
            </p>

            <p className="cookie-layer-details-box-text">
              Diese Cookies helfen uns dabei, die Bedienung der Website zu
              ermöglichen. Sie stellen Grundfunktionen sicher und sind daher
              nicht deaktivierbar.
            </p>

            <p className="cookie-layer-details-box-headline">
              <b>Statistik:</b>
            </p>

            <p className="cookie-layer-details-box-text">
              Mit Hilfe dieser Cookies erfassen wir anonymisierte Daten für
              Statistiken und Analysen, um unser Angebot und unseren
              Internetauftritt zu verbessern und zu optimieren. Beispielsweise
              sammeln wir Informationen über das Nutzerverhalten auf unserer
              Internetseite, wie z.B. die Anzahl der Besuche, die
              durchschnittliche Verweilzeit oder die aufgerufenen Seiten.
            </p>

            {/*     <p className="cookie-layer-details-box-headline">
            <b>Marketing:</b>
          </p>

          <p className="cookie-layer-details-box-text">
            
            Diese Cookies werden genutzt, um Ihnen innerhalb und außerhalb
            unserer Websites Werbung zu präsentieren, die auf Ihre Interessen
            abgestimmt ist.
          </p> */}
          </div>
          <div className="cookie-layer-buttons">
            <div className="cookie-layer-button">
              <button
                type="button"
                onClick={handleAllSelect}
                /* disabled={areAllSelected} */
              >
                Alle auswählen und bestätigen
              </button>
            </div>
            <di className="cookie-layer-button">
              <button type="button" onClick={handleSelectionConfirm}>
                Auswahl bestätigen
              </button>
            </di>
          </div>
          <div className="modal-footer-noflex">
            <div className="modal-section">
              <div className="questionWrapper">
                <h5>Rechtliche Hinweise</h5>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <div className="link-container">
              <a href="/impressum/" target="_blank">
                Impressum
              </a>
            </div>
            <div className="link-container">
              <a href="/datenschutz/" target="_blank">
                Datenschutz
              </a>
            </div>
            <div className="link-container">
              <a href="/nutzungsbedingungen/" target="_blank">
                Nutzungsbedingungen
              </a>
            </div>
            <div className="link-container">
              <a href="/teilnahmebedingungen/" target="_blank">
                Teilnahmebedingungen
              </a>
            </div>
          </div>
        </div>
      </div>
      <a onClick={changeCookies} className="cookie-change-link">
        {cookieContent}
      </a>
    </div>
  );
};

export default CookieConsent;
